import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Integrationen(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Erweiterungen"
      title="Integrationen – Verbinden Sie Ihre Tools"
      subtitle="Saldify verbindet sich nahtlos mit Ihren bestehenden Tools: Shopsysteme, Zahlungsanbieter, Banken und mehr."
      heroImage="/screenshots/app-banking.webp"
      heroImageAlt="Angebundene Konten und Zahlungsdienstleister in Saldify"
      features={[
        {
          title: 'Shopsysteme',
          description: 'Automatischer Rechnungsimport aus Shopify, WooCommerce, Magento und mehr.',
        },
        {
          title: 'Zahlungsanbieter',
          description: 'Direkte Anbindung an PayPal, Stripe, Klarna für automatische Zahlungszuordnung.',
        },
        {
          title: 'Banking',
          description: 'Verbinden Sie über 4.000 Banken und Sparkassen für automatischen Kontoabgleich.',
        },
        {
          title: 'Marktplätze',
          description: 'Amazon, eBay, Etsy – importieren Sie Verkäufe automatisch.',
        },
        {
          title: 'Buchhaltungssoftware',
          description: 'Export zu DATEV, ADDISON, Lexware und anderen Programmen.',
        },
        {
          title: 'API-Zugang',
          description: 'Entwickeln Sie eigene Integrationen mit unserer REST-API (Business-Tarif).',
        },
      ]}
      sections={[
        {
          title: 'E-Commerce automatisieren',
          description: 'Verbinden Sie Ihren Online-Shop und Saldify erstellt automatisch Rechnungen für jede Bestellung. Keine manuelle Arbeit mehr.',
          bullets: [
            'Shopify, WooCommerce, Magento',
            'Automatische Rechnungserstellung',
            'Bestelldaten synchronisieren',
            'Retouren und Gutschriften',
          ],
          imageSide: 'right',
        },
        {
          title: 'Banking-Integration',
          description: 'Verbinden Sie Ihre Bankkonten und Saldify ordnet Zahlungseingänge automatisch den richtigen Rechnungen zu.',
          bullets: [
            'Über 4.000 Banken unterstützt',
            'Täglicher Kontoabgleich',
            'Automatische Zuordnung',
            'Offene Posten im Blick',
          ],
          imageSide: 'left',
        },
        {
          title: 'Für Entwickler: Die Saldify API',
          description: 'Mit der REST-API können Sie Saldify in Ihre eigenen Systeme integrieren. Erstellen Sie Rechnungen, rufen Sie Daten ab oder automatisieren Sie Workflows.',
          bullets: [
            'RESTful API',
            'Umfangreiche Dokumentation',
            'Webhooks für Echtzeit-Updates',
            'SDKs für gängige Sprachen',
          ],
          imageSide: 'right',
        },
      ]}
      ctaTitle="Verbinden Sie Ihre Tools"
      ctaDescription="Entdecken Sie alle verfügbaren Integrationen und automatisieren Sie Ihre Buchhaltung."
    />
  );
}
